export class AjsBsModalService {
    hide( id ) {
        debugger;
    }
}